import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const TagTitle = styled.h3`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;

  margin: 0 0 16px 0;
`;

export const TagSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;
